<template>
  <v-container fluid tag="section" class="module-report-container">
    <v-row>
      <v-col cols="8" style="width:75%">
        <h2 class="text-h5 font-weight-bold" style="width: fit-content;border-bottom: 2px solid rgba(233, 30, 99, 1);margin-top: 15px !important;">VH Edtech</h2>
      </v-col>
      <v-col cols="4">
       <div class="d-flex align-center justify-end" style="column-gap: 10px">
         <div style="width: calc(100% - 115px)">
           <common-range-picker
               v-model="selectRange"
               :clearable="false"
               :aLight="'left'"
               :defaultRange="defaultRange"
               :label="'Tìm kiếm theo thời gian'"
           />
         </div>
         <v-btn style="margin-top: 6px;margin-bottom: 0 !important;margin-right: 0 !important;" @click="changeDateRange(selectRange)" color="primary">Tìm kiếm</v-btn>
       </div>
      </v-col>
    </v-row>
    <table-module-report :data="data" />
  </v-container>
</template>

<script>
import moment from 'moment'
import RepositoryFactory from "@/repositories/RepositoryFactory"
import TableModuleReport from "@/pages/report/general-module-report/components/TableModuleReport.vue";

const ReportRepository = RepositoryFactory.get('report')

export default {
  components: {
    TableModuleReport,
  },
  data() {
    return {
      filterForm: {
        dateRange: {
          startDate: moment().startOf('week').format('YYYY-MM-DD'),
          endDate: moment().endOf('week').format('YYYY-MM-DD'),
        }
      },
      defaultRange: {
        startDate: moment().startOf('week').format('YYYY-MM-DD'),
        endDate: moment().endOf('week').format('YYYY-MM-DD'),
      },
      selectRange: [
        moment().startOf('week').format('YYYY-MM-DD'),
        moment().endOf('week').format('YYYY-MM-DD')
      ],
      total: {},
      data: [],
      dataChildTable: []
    }
  },
  created() {
    this.getDataType()
  },
  methods: {
    async getDataType() {
      const loading = this.$loading.show()
      const params = {
        startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
      }
      const res = await ReportRepository.moduleTypeReportAllApi(params)

      if (res.success) {
        this.data = _.get(res, 'data', [])
      } else {
        this.data = []
        this.$swal({
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
      loading.hide()
    },

    async getDataSchoolLevel() {
      const loading = this.$loading.show()
      const params = {
        startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
      }
      const res = await ReportRepository.moduleSchoolLevelReport(params)

      if (res.success) {
        this.data = _.get(res, 'data.schoolLevels', [])
        this.total = _.get(res, 'data.total', {})
      } else {
        this.data = []
        this.total = {}
        this.$swal({
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
      loading.hide()
    },

    changeDateRange(selectRange) {
      const loading = this.$loading.show()
      this.filterForm.dateRange = {
        startDate: moment(selectRange[0]).format('YYYY-MM-DD'),
        endDate: moment(selectRange[1]).format('YYYY-MM-DD'),
      };
      this.selectRange = selectRange
      this.getDataType()
      loading.hide()
      // this.changeTab(this.tab)
    }

  }
}
</script>

<style scoped>
.module-report-container {
  background: white;
}
</style>